import { createRouter, createWebHistory } from "vue-router"
import store from "@/store"

import EmblemPage from "@/pages/EmblemPage.vue"
import MainPage from "@/pages/MainPage"
import GamePage from "@/pages/GamePage"
import AboutPage from "@/pages/AboutPage"
import DeckbuildPage from "@/pages/DeckbuildPage"
import LevelPage from "@/pages/LevelPage"
import LoginPage from "@/pages/LoginPage"
import SettingsPage from "@/pages/SettingsPage"
import BonusPage from "@/pages/BonusPage"
import RulesPage from "@/pages/RulesPage"
import WinPage from "@/pages/WinPage"
import LoadingPage from "@/pages/LoadingPage"
import StartGame from "@/pages/StartGame"
import LosePage from "@/pages/LosePage"

import { images } from "@/router/const/images"

const routes = [
  {
    path: "/",
    component: EmblemPage,
    meta: {
      requireAuth: false,
      notRequireMenu: true,
    },
  },
  {
    path: "/main",
    component: MainPage,
    meta: {
      requireAuth: false,
      image: images.main,
    },
  },
  {
    path: "/loading",
    component: LoadingPage,
    meta: {
      requireAuth: false,
      notRequireMenu: true,
      image: images.loading,
    },
  },
  {
    path: "/login",
    component: LoginPage,
    meta: {
      requireAuth: false,
      image: images.login,
      notRequireMenu: true,
    },
  },
  {
    path: "/start_game",
    component: StartGame,
    meta: {
      requireAuth: true,
      image: images.start_game,
    },
  },
  {
    path: "/game",
    component: GamePage,
    meta: {
      requireAuth: true,
      notRequireMenu: true,
      image: images.field,
    },
  },
  {
    path: "/about",
    component: AboutPage,
    meta: {
      requireAuth: false,
      image: images.work_in_progress,
    },
  },
  {
    path: "/deckbuild",
    component: DeckbuildPage,
    meta: {
      requireAuth: true,
      image: images.deckbuild,
      withGradient: true,
    },
  },
  {
    path: "/levelselect",
    component: LevelPage,
    meta: {
      requireAuth: true,
      image: images.levels,
    },
  },
  {
    path: "/settings",
    component: SettingsPage,
    meta: {
      requireAuth: true,
      image: images.work_in_progress,
    },
  },
  {
    path: "/bonus",
    component: BonusPage,
    meta: {
      requireAuth: true,
      image: images.bonus,
    },
  },
  {
    path: "/rules",
    component: RulesPage,
    meta: {
      requireAuth: false,
      image: images.work_in_progress,
    },
  },
  {
    path: "/win",
    component: WinPage,
    meta: {
      requireAuth: true,
      image: images.win,
    },
  },
  {
    path: "/lose",
    component: LosePage,
    meta: {
      requireAuth: true,
      image: images.lose,
    },
  },
]

const router = createRouter({
  routes,
  mode: "history",
  history: createWebHistory(),
})

router.beforeEach((to, from, next) => {
  // это чтобы стрелкой назад не попасть на страницу загрузки и не зависнуть там
  // ведь мы на неё можем попасть ИЛИ с Эмблемы, ИЛИ с логина
  if (to.path === "/loading" && from.path === "/main") {
    next(false)
    return
  }

  // Если требуется АУФ, и мы залогинены, все ок. Если не залогинены, идем на главную.
  // Если не требуется АУФ - все ок
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (store.getters.isLoggedIn) next()
    else next("/")
  } else next()

  // если мы уже играли и оттуда вышли, переустановим колоду на ту, которой играли
  if (from.path === "/game") store.dispatch("re_set_deck")
})

export default router
